import React from 'react';
import { CtaButton } from '../ui/CtaButton';
import { CreditCard, ShieldCheck } from 'lucide-react';
export function ClosingSection() {
  return <section className="py-24 bg-brand-teal text-white" data-id="element-35">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-36">
        <div className="mb-16 space-y-6 text-lg text-brand-sand/90" data-id="element-37">
          <p className="text-2xl font-serif font-bold text-white mb-8" data-id="element-38">
            Tu práctica profesional merece un sistema.
          </p>
          <p data-id="element-39">No protocolos sueltos buscados en Google a las 11 de la noche.</p>
          <p data-id="element-40">
            La diferencia entre el nutricionista que sabe nutrición y el que
            ejerce la nutrición con excelencia no está en haber hecho más
            cursos.
          </p>
          <p data-id="element-41">
            Está en tener las herramientas correctas, organizadas, listas para
            usar, adaptadas a la realidad de tu consultorio y de tus pacientes.
          </p>
          <p className="font-bold text-white text-xl pt-4" data-id="element-42">
            Eso es exactamente lo que el Arsenal del Nutri entrega.
          </p>
        </div>

        <div className="bg-white text-brand-charcoal rounded-2xl p-8 sm:p-12 shadow-2xl max-w-xl mx-auto" data-id="element-43">
          <h2 className="text-2xl font-serif font-bold mb-1" data-id="element-44">
            EL ARSENAL DEL NUTRI
          </h2>
          <p className="text-brand-teal font-bold tracking-widest uppercase text-sm mb-8" data-id="element-45">
            Sistema Operativo 360°
          </p>

          <div className="mb-8" data-id="element-46">
            <p className="text-4xl font-bold text-brand-teal mb-2" data-id="element-47">
              $19.990 ARS
            </p>
            <p className="text-gray-500 text-sm" data-id="element-48">
              Descarga inmediata · Garantía de 7 días
            </p>
          </div>

          <CtaButton isFinal fullWidth className="mb-8" data-id="element-49">
            QUIERO EL ARSENAL AHORA
          </CtaButton>

          <div className="border-t border-gray-200 pt-6 space-y-4" data-id="element-50">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-gray-600" data-id="element-51">
              <div className="flex items-center gap-2" data-id="element-52">
                <CreditCard className="w-4 h-4" data-id="element-53" />
                <span data-id="element-54">Visa · Mastercard · Amex</span>
              </div>
              <div className="hidden sm:block text-gray-300" data-id="element-55">•</div>
              <div className="flex items-center gap-2" data-id="element-56">
                <CreditCard className="w-4 h-4" data-id="element-57" />
                <span data-id="element-58">Débito · Transferencia · MP</span>
              </div>
            </div>
            <div className="flex items-center justify-center gap-2 text-sm font-medium text-brand-teal bg-brand-teal/5 py-2 rounded-lg" data-id="element-59">
              <ShieldCheck className="w-4 h-4" data-id="element-60" />
              <span data-id="element-61">Pago 100% seguro con MercadoPago</span>
            </div>
          </div>
        </div>

        <div className="mt-16 opacity-60 text-sm" data-id="element-62">
          <p className="font-bold tracking-widest" data-id="element-63">EL ARSENAL DEL NUTRI™</p>
          <p data-id="element-64">
            Porque tu práctica profesional merece un sistema. No improvisación.
          </p>
        </div>
      </div>
    </section>;
}